module.exports = __webpack_public_path__ + "14_hair_brown.f323e841.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/14_hair_brown.png
// module id = gyX7
// module chunks = 0